<template>
  <PageLayout class="pets-page">
    <div class="pets-page__title">
      <PageTitle>Розрахунок вартості страхування тварин</PageTitle>
      <Breadcrumbs
        class="pets-page__breadcrumbs"
        :breadcrumbs="getBreadcrumbs"
      />
    </div>
    <div class="pets-page__calculator">
      <Calculator />
    </div>
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { Calculator } from '@/features/pets-calculator';
import { Breadcrumbs } from '@/shared/ui/breadcrumbs';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { Breadcrumbs, PageTitle, PageLayout, Calculator },
  computed: {
    getBreadcrumbs() {
      return [
        {
          title: 'Панель управління',
          url: '#',
        },
        {
          title: 'Страхування тварин',
          url: '#',
        },
      ];
    },
  },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.pets-page {
  font-family: 'Geist', sans-serif;
  font-size: 14px;
  color: #09090B;

  &__title {
    margin-bottom: 24px;
  }

  &__breadcrumbs {
    margin-bottom: 0;
  }
}
</style>
